import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import { useState } from 'react';
import { handlePasswordReset } from '../auth';

function ForgotPassword({ open, handleClose }) {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  // Function to handle password reset
  const handleReset = async () => {
    try {
      await handlePasswordReset(email);
      setMessage("Password reset email sent! Check your inbox.");
      setError("");
    } catch (err) {
      setError("Error resetting password: " + err.message);
    }
  };
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>Reset password</DialogTitle>
      <DialogContent
        sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}
      >
        <DialogContentText>
          Enter your account&apos;s email address, and we&apos;ll send you a link to
          reset your password.
        </DialogContentText>
        <OutlinedInput
          autoFocus
          required
          margin="dense"
          id="email"
          name="email"
          label="Email address"
          placeholder="Email address"
          type="email"
          fullWidth
          onChange={handleEmailChange}
        />
      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3 }}>
        <Button onClick={handleClose}>Cancel</Button>
        <Button variant="contained" type="button" onClick={(event) => {
          event.preventDefault();
          handleReset();
          handleClose();
        }}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ForgotPassword;